import React from 'react';
import AsyncPage from './async';
import {Route} from 'react-router-dom';
import DefaultBusinessLayout from '../../../../components/layout/DefaultBusinessLayout';

export default [
  <Route key="/business/user/forgot-password" element={<DefaultBusinessLayout />}>
    <Route path="business/user/forgot-password" element={<AsyncPage />} />
  </Route>,
];
